import useSWR from 'swr';

import { usePrivate } from '@/components/private/PrivateContext';
import { enqueueSnackbar } from '@/providers/SnackbarProvider';

import { useGetAnimalTraitCategoriesMessages } from './messages';

export function getAnimalTraitCategoriesCacheKey(organisationId?: number) {
  return `/api/AnimalTraitCategory?organisationId=${organisationId}`;
}

export interface useGetAnimalTraitCategoriesOptions {
  shouldFetch?: boolean;
}

export function useGetAnimalTraitCategories(
  organisationId?: number,
  options?: useGetAnimalTraitCategoriesOptions,
) {
  const mergedOptions: useGetAnimalTraitCategoriesOptions = {
    shouldFetch: true,
    ...options,
  };

  const { entityDetailCategoryApi } = usePrivate();

  const results = useSWR(
    entityDetailCategoryApi && mergedOptions.shouldFetch
      ? getAnimalTraitCategoriesCacheKey(organisationId)
      : null,
    () => entityDetailCategoryApi?.apiEntityDetailCategoryGet(),
    {
      onError: (error) => {
        enqueueSnackbar(
          useGetAnimalTraitCategoriesMessages[
            'useGetAnimalTraitCategories.fetch.unexpectedError'
          ],
          {
            variant: 'error',
          },
        );
        console.error(
          '[BREEDLOGIC] <useGetAnimalTraitCategories> error fetching trait categories.',
          error,
        );
      },
    },
  );

  const isLoadingOrValidating =
    results.isLoading || results.isValidating || !entityDetailCategoryApi;

  return { ...results, isLoadingOrValidating };
}
